import { HOT_TOPICS } from '@/mocks/kanliao';

export default function HotTopics() {
  return (
    <section id="topics" className="w-full py-12 md:py-16">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)] lg:gap-12">
          {/* left intro */}
          <div className="flex flex-col">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                <i className="ri-fire-line text-xl" />
              </span>
              <h2 className="font-heading text-2xl font-black tracking-tight text-foreground-950 md:text-3xl">
                话题热榜
              </h2>
            </div>
            <p className="mt-4 font-heading text-lg font-semibold leading-relaxed text-foreground-800">
              最近大家点进去最多的
              <span className="text-accent-600">话题与入口</span>
              ，跟着热度挑，不容易踩空。
            </p>
            <p className="mt-3 text-sm leading-6 text-foreground-600">
              榜单来自看料导航内各直达入口的近期访问热度，供选片、追更、蹲直播时参考。热度越高的入口，越可能是当下的热门去处。
            </p>

            <div className="mt-6 grid grid-cols-3 gap-3">
              {[
                { k: 'Top', v: '3', d: '热度最高' },
                { k: '↑', v: '5', d: '本周上升' },
                { k: '新', v: '2', d: '新晋话题' },
              ].map((t) => (
                <div key={t.d} className="rounded-lg border border-background-200 bg-background-100 p-3 text-center">
                  <div className="font-heading text-xl font-black text-primary-700">
                    {t.v}
                    <span className="ml-1 text-xs font-medium text-foreground-500">{t.k}</span>
                  </div>
                  <div className="mt-0.5 text-[11px] text-foreground-500">{t.d}</div>
                </div>
              ))}
            </div>
          </div>

          {/* right heat list */}
          <div className="flex flex-col divide-y divide-background-200 rounded-xl border border-background-200 bg-background-50 px-5 py-2 md:px-6">
            {HOT_TOPICS.map((t, i) => {
              const top = i < 3;
              return (
                <button
                  key={t.name}
                  type="button"
                  className="group flex cursor-pointer items-center gap-3 py-3.5 text-left md:gap-4"
                >
                  <span
                    className={`serif-num w-8 shrink-0 text-xl font-black ${
                      top ? 'text-accent-600' : 'text-foreground-300 group-hover:text-primary-500'
                    }`}
                  >
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span
                    className={`flex-1 truncate whitespace-nowrap text-sm font-medium md:text-base ${
                      top ? 'text-foreground-950' : 'text-foreground-700'
                    }`}
                  >
                    {t.name}
                  </span>
                  <span className="hidden h-1.5 w-20 overflow-hidden rounded-full bg-background-200 sm:block md:w-28">
                    <span
                      className={`block h-full rounded-full ${top ? 'bg-accent-500' : 'bg-primary-400/60'}`}
                      style={{ width: `${t.heat}%` }}
                    />
                  </span>
                  <span className={`w-7 shrink-0 text-right text-xs font-bold ${top ? 'text-accent-700' : 'text-foreground-400'}`}>
                    {t.heat}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}